import type { MetricColorRange } from "../types/feedstockTypes"

export const getMetricColor = (ranges: MetricColorRange[], value: number): string => {
  let color = ""
  ranges.forEach((r) => {
    if (value < r.upper && value >= r.lower) {
      color = r.color
    }
  })

  return color
}
